/* globals Backbone */

define('components/click-and-reveal-author/models/paragraph-editor-control',[], function() {
    "use strict";
    var ParagraphEditorControlModel = Backbone.Model.extend({
        "defaults": function() {
            return {
                "paragraphIndex": 0,
                "wordControlModel": null,
                "hotspots": [],
                "editorContent": null,
                "selectedHighlightedBlock": [],
                "bounds": {
                    "top": 0,
                    "left": 0,
                    "width": ParagraphEditorControlModel.DEFAULT_EDITOR_SIZE.WIDTH,
                    "height": ParagraphEditorControlModel.DEFAULT_EDITOR_SIZE.HEIGHT
                },
                "cachedBounds": {
                    "top": 0,
                    "left": 0,
                    "width": ParagraphEditorControlModel.DEFAULT_EDITOR_SIZE.WIDTH,
                    "height": ParagraphEditorControlModel.DEFAULT_EDITOR_SIZE.HEIGHT
                },
                "richText": null
            };
        },

        "updateParagraphBounds": function(bounds) {
            var obj = null,
                modelBounds = this.get('cachedBounds');
            for (obj in bounds) {
                if (modelBounds.hasOwnProperty(obj)) {
                    modelBounds[obj] = Number(bounds[obj]);
                }
            }
            return this;
        }
    }, { //static part here

        "BUTTON_TEXT": {
            "SPECIFY_BLOCK_TEXT": "Specify Clickable Blocks",
            "SAVE_TEXT": "Save",
            "SAVEBLOCK_TEXT": "Save Block",
            "DELETEBLOCK_TEXT": "Delete Block"
        },
        "DEFAULT_EDITOR_SIZE": {
            "WIDTH": 287,
            "HEIGHT": 201
        }
    });
    return ParagraphEditorControlModel;
});

